function convertName(name: string): string {
  const map: Record<string, string> = {
    kochi: 'kouchi',
    donan: 'dounan',
    dohoku: 'douhoku',
    doo: 'douou',
    dotou: 'doutou'
  }
  return map[name] ?? name
}

export function getAreaKeyByPrefKey(prefKey: string) {
  if (prefKey === 'okinawa') {
    return 'okinawa'
  }
  for (const area of areaToPrefTable) {
    if (area.pref_list.some((pref) => pref.key === prefKey)) {
      return area.key
    }
  }
  return undefined
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path === '/cgi/search_result.fcgi/') {
    const id = to.query.id
    if (!id) return navigateTo('/', { redirectCode: 301 })
    try {
      const data = await $fetch('/api/golf/info')
      for (const [key, item] of Object.entries(data)) {
        const typedItem = item as { id: string }
        if (typedItem.id === id) {
          return navigateTo(key, { redirectCode: 301 })
        }
      }
      return navigateTo('/', { redirectCode: 301 })
    } catch (error) {
      console.error('古いurlからのリダイレクト時のエラー:', error)
      return navigateTo('/', { redirectCode: 301 })
    }
  }
  const htmlMatch = to.path.match(/^\/(?:golf\/)?html\/([a-zA-Z0-9_-]+)\.html\/?$/)
  if (htmlMatch) {
    const pref = convertName(htmlMatch[1])
    const areaMatch = pref.match(/^([a-zA-Z0-9_-]+)-area$/)
    if (areaMatch) {
      const area = convertName(areaMatch[1])
      return navigateTo(`/${area}/`, { redirectCode: 301 })
    }
    const area = getAreaKeyByPrefKey(pref)
    if (area) {
      if (area === 'okinawa') {
        return navigateTo(`/${area}/`, { redirectCode: 301 })
      }
      return navigateTo(`/${area}/${pref}/`, { redirectCode: 301 })
    }
    return navigateTo('/', { redirectCode: 301 })
  }
  const xmlMatch = to.path.match(/^\/(?:golf\/)?xml\/([a-zA-Z0-9_-]+)\.xml\/?$/)
  if (xmlMatch) {
    const param = convertName(xmlMatch[1])
    if (param === 'whole-country') {
      return navigateTo('/', { redirectCode: 301 })
    }
    const areaMatch = param.match(/^([a-zA-Z0-9_-]+)-area$/)
    if (areaMatch) {
      const area = convertName(areaMatch[1])
      return navigateTo(`/${area}/`, { redirectCode: 301 })
    }
    const area = getAreaKeyByPrefKey(param)
    if (area) {
      if (area === 'okinawa') {
        return navigateTo(`/${area}/`, { redirectCode: 301 })
      }
      return navigateTo(`/${area}/${param}/`, { redirectCode: 301 })
    } else {
      const data = await $fetch('/api/golf/info')
      for (const [key, item] of Object.entries(data)) {
        const typedItem = item as { id: string }
        if (typedItem.id === param) {
          return navigateTo(key, { redirectCode: 301 })
        }
      }
    }
    return navigateTo('/', { redirectCode: 301 })
  }
})
